const { default: axiosClient } = require("./axiosClient");

const KhuyenCaoPhanBonApi = {
    getPaging: (params) => {
        const url = '/gopy/paging';
        return axiosClient.get(url, {params});
    },

    getDetail: (x,y) =>{
        const url = '/mappublic/getkhuyencaophanbon?x=' + x + '&y=' + y;
        return axiosClient.get(url);
    },
    
    getAll: (params) =>{
        const url = 'gopy/getall';
        return axiosClient.get(url, {params});
    }
}

export default KhuyenCaoPhanBonApi;